export const locale = {
    lang: 'cs',
    data: {
        HTTP: {
            0: 'Server nedostupný nebo neočekávaná chyba při zpracování',
            400: 'Chybný požadavek',
            401: 'Neautorizovaný požadavek',
            403: 'Přístup odepřen',
            404: 'Požadavek nenalezen',
            405: 'Požadavek předán špatným způsobem',
            500: 'Neočekávaná chyba serveru',
        },
        GUARD: {
            NO_INVESTMENT_PROFILE: 'Neexistuje investiční profil',
        },
        ERROR_CODE: {
            ADVISORMISSINGLIFECERTIFICATION: 'Chybí potřebná certifikace pro životní pojištění',
            ADVISORMISSINGINVESTMENTCERTIFICATE: 'Chybí potřebná certifikace pro investice',
            ALREADYREQUESTED: 'Jiný požadavek již existuje',
            AMLRISKFORBIDDEN: 'Finanční plán nelze vygenerovat - klient nesplňuje některou z podmínek AML',
            CLIENTIDENTITYCARDISNOTVALID: 'Doklad totožnosti je nevalidní',
            CLIENTIDENTITYCARDNOTFOUND: 'Doklad totožnosti nenalezen',
            CLIENTISACTUALADVISOR: 'Rodné číslo klienta je stejné jako přihlášeného poradce',
            CONFIRMATIONREQUESTERROR: 'Nepodařilo se vytvořit požadavek na podpis',
            CONTRACTNOEXIST: 'Smlouva neexistuje',
            CONTRACTORPROPOSALNUMBERISNULLOREMPTY: 'Číslo smlouvy nebo návrhu je prázdné',
            DOCUMENTCOUNTISNOTSAMEASINDB: 'Počet dokumentů není shodný počtu v DB',
            DOCUMENTERROR: 'Chyba dokumentu',
            DOCUMENTSAREFORMORETHANONEPERSON: 'Dokumenty jsou pro více než jednu osobu',
            DOCUMENTTYPEUPLOADNOTALLOWED: 'Typ dokumentu není povolen k nahrávání',
            EMPLOYERINVALID: 'Chybí údaje o zaměstnavateli',
            GAPANALYSISFORPERSONNOTFOUND: 'GAP analýza nebyla pro danou osobu nalezena',
            GAPANALYSISNOTCOMPLETED: 'GAP analýze není kompletní',
            IDENTIFICATIONATEMPTY: 'Není vyplněno datum identifikace',
            INVALIDDOCUMENTTYPE: 'Nevalidní typ dokumentu',
            INVALIDPERSON: 'Nevalidní osoba',
            INVALIDPERSONIDENTIFICATION: 'Chybějící nebo nevalidní identifikačni údaje (AML, doklad totožnosti)',
            LEGALPERSONADDRESSISNOTVALID: 'Adresa právnické osoby není validní',
            LEGALPERSONADDRESSISNULL: 'Adresa právnické osoby není vyplněna',
            LEGALPERSONISNOTNULL: 'Jedná se o právnickou osobu',
            LEGALPERSONISNOTVALID: 'Právnická osoba není validní',
            LINKSENDFAILED: 'Odeslání odkazu selhalo',
            MISSINGLEGALPERSONRISKFACTOR: 'Právnická osoba nemá vybraný risk faktor',
            MISSINGAMLCERTIFICATION: 'Platnost Vašeho AML testu vypršela. Finanční plán nelze generovat. Informace naleznete <a href="https://wiki.siriusfinance.cz/hr-vzdelavani-a-etika/vzdelavani/aml-aid9229-aid9210/aml-test-aid9349" target="_blank">zde</a>.',
            MISSINGFINPLAN: 'Chybí podepsaný Finanční plán',
            MISSINGCERTIFICATION: 'Chybí certifikace',
            MULTIPLEPERSONSINDOCUMENTS: 'V dokumentech se nachází více osob',
            NODOCUMENT: 'Dokument neexistuje',
            NOTEXISTCOOPERATIONAGREEMENT: 'Neexistuje Dohoda o spolupráci',
            NOTSIGNABLEDOCUMENTFORMAT: 'Formát dokumentu nelze podepsat',
            NOTSUPPPORTEDFILEEXTENSION: 'Nepodporovaná koncovka dokumentu',
            PENDINGLEGALAPPROVAL: 'Finanční plán nelze generovat, předcházející plán čeká na kontrolu compliance',
            PERSONBIRTHNUMBERAUTOERROR: 'Chyba při generovaní identifikačního čísla',
            PERSONBIRTHNUMBERISNULL: 'Není vyplněno rodné číslo',
            PERSONCONTACTISNOTVALID: 'Kontaktní údaje nejsou validní',
            PERSONDOMICILEADDRESSISNOTVALID: 'Adresa trvalého bydliště není validní',
            PERSONDOMICILEADDRESSISNULL: 'Adresa trvalého bydliště není vyplněna',
            PERSONFINBILANCEISNEGATIVE: 'Finanční bilance je záporná',
            PERSONGENDERISNULL: 'Pohlaví osoby není vyplněno',
            PERSONMONTHLYEXPENSEISNULL: 'Měsíční výdaje nejsou vyplněny',
            PERSONMONTHLYINCOMEISNULL: 'Měsíční příjmy nejsou vyplněny',
            PERSONNOTFOUND: 'Osoba nenalezena',
            PERSONRELATIONNOTPARTNERORCLIENT: 'Osoba není partner, ani klient',
            PERSONSTATUSNOTCLIENT: 'Osoba není klientem',
            PERSONVALIDATIONFAILED: 'Validace osoby vrátila chybu',
            PHYSICALPERSONISNOTVALID: 'Fyzická osoba není validní',
            PORTFOLIOEMPTY: 'Finanční plán nejde vygenerovat, pokud neobsahuje žádný produkt',
            PROCEEDINGSRECORDFORPERSONNOTFOUND: 'ZZJ nenalezeno pro danou osobu',
            QUESTIONILLEGALMULTICHOICE: 'Dotazník obsahuje multivýběr, kde není dovolen',
            QUESTIONMISSINGANSWER: 'Dotazník obsahuje nezodpovězené otázky',
            QUESTIONNAIRENOTFOUND: 'Klient nemá vyplněný investiční dotazník',
            SECTIONAISNOTVALID: 'Sekce A není validní',
            SECTIONBISNOTVALID: 'Sekce B není validní',
            SECTIONCISNOTVALID: 'Sekce C není validní',
            SECTIONDISNOTVALID: 'Sekce D není validní',
            SECTIONEISNOTVALID: 'Sekce E není validní',
            SECTIONFISNOTVALID: 'Sekce F není validní',
            SECTIONHISNOTVALID: 'Sekce H není validní',
            SECTIONIISNOTVALID: 'Sekce I není validní',
            // zzj
            FORMNOTFOUND: 'Nenalezen ZZJ formulář pro danou osobu',
            FORMLOCKED: 'ZZJ formulář pro danou osobu je uzamčen',
            FORMERRORS: 'ZZJ formulář obsahuje chyby',
            CALCULATIONERRORS: 'Chyba při kalkulaci SRRI',
            NOINVESTMENTPRODUCT: 'Žádný investiční produkt',
            TIMELINENOTOBSERVED: 'Nedodržená časová osa',
            INVESTMENTQUESTIONNAIREDIFFERENTADVISOR: 'ID musí sjednat stejný poradce',
            INVALIDFORMDEALDATE: 'Nevalidní datum sjednání (nemsí být před podpisem ID nebo v budoucnu)',
            // guard
            ANSWERSGUARDFAILED: 'Chyba validace odpovědí v dotazníku',
            //
            JOBTITLENOTSPECIFIED: 'Pracovní pozice není vyplněna',
            IDENTIFICATIONNUMBERREQUIRED: 'U klienta není uvedeno IČ',
            IDENTIFICATIONNUMBERINVALID: 'IČ u klienta není validní',
        },
        CODE: {
            COUNTRY: {
                AD: 'Andorra',
                AE: 'Spojené arabské emiráty',
                AF: 'Afghánistán',
                AG: 'Antigua a Barbuda',
                AI: 'Anguilla',
                AL: 'Albánie',
                AM: 'Arménie',
                AO: 'Angola',
                AQ: 'Antarktida',
                AR: 'Argentina',
                AS: 'Americká Samoa',
                AT: 'Rakousko',
                AU: 'Austrálie',
                AW: 'Aruba',
                AX: 'Alandy',
                AZ: 'Ázerbájdžán',
                BA: 'Bosna a Hercegovina',
                BB: 'Barbados',
                BD: 'Bangladéš',
                BE: 'Belgie',
                BF: 'Burkina Faso',
                BG: 'Bulharsko',
                BH: 'Bahrajn',
                BI: 'Burundi',
                BJ: 'Benin',
                BL: 'Svatý Bartoloměj',
                BM: 'Bermudy',
                BN: 'Brunej',
                BO: 'Bolívie',
                BQ: 'Bonaire, Svatý Eustach a Saba',
                BR: 'Brazílie',
                BS: 'Bahamy',
                BT: 'Bhútán',
                BV: 'Bouvetův ostrov',
                BW: 'Botswana',
                BY: 'Bělorusko',
                BZ: 'Belize',
                CA: 'Kanada',
                CC: 'Kokosové ostrovy',
                CD: 'Demokratická republika Kongo',
                CF: 'Středoafrická republika',
                CG: 'Kongo',
                CI: 'Pobřeží slonoviny',
                CK: 'Cookovy ostrovy',
                CL: 'Chile',
                CM: 'Kamerun',
                CN: 'Čína',
                CO: 'Kolumbie',
                CR: 'Kostarika',
                CU: 'Kuba',
                CV: 'Kapverdy',
                CW: 'Curaçao',
                CX: 'Vánoční ostrov',
                CY: 'Kypr',
                CZ: 'ČR',
                DE: 'Německo',
                DJ: 'Džibutsko',
                DK: 'Dánsko',
                DM: 'Dominika',
                DO: 'Dominikánská republika',
                DZ: 'Alžírsko',
                EC: 'Ekvádor',
                EE: 'Estonsko',
                EG: 'Egypt',
                EH: 'Západní Sahara',
                ER: 'Eritrea',
                ES: 'Španělsko',
                ET: 'Etiopie',
                FI: 'Finsko',
                FJ: 'Fidži',
                FK: 'Falklandy (Malvíny)',
                FM: 'Mikronésie',
                FO: 'Faerské ostrovy',
                FR: 'Francie',
                GA: 'Gabon',
                GB: 'Spojené království Velké Británie a Severního Irska',
                GD: 'Grenada',
                GE: 'Gruzie',
                GF: 'Francouzská Guyana',
                GG: 'Guernsey',
                GH: 'Ghana',
                GI: 'Gibraltar',
                GL: 'Grónsko',
                GM: 'Gambie',
                GN: 'Guinea',
                GP: 'Guadeloupe',
                GQ: 'Rovníková Guinea',
                GR: 'Řecko',
                GS: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
                GT: 'Guatemala',
                GU: 'Guam',
                GW: 'Guinea-Bissau',
                GY: 'Guyana',
                HK: 'Hongkong',
                HM: 'Heardův ostrov a McDonaldovy ostrovy',
                HN: 'Honduras',
                HR: 'Chorvatsko',
                HT: 'Haiti',
                HU: 'Maďarsko',
                CH: 'Švýcarsko',
                ID: 'Indonésie',
                IE: 'Irsko',
                IL: 'Izrael',
                IM: 'Ostrov Man',
                IN: 'Indie',
                IO: 'Britské indickooceánské území',
                IQ: 'Irák',
                IR: 'Írán',
                IS: 'Island',
                IT: 'Itálie',
                JE: 'Jersey',
                JM: 'Jamajka',
                JO: 'Jordánsko',
                JP: 'Japonsko',
                KE: 'Keňa',
                KG: 'Kyrgyzstán',
                KH: 'Kambodža',
                KI: 'Kiribati',
                KM: 'Komory',
                KN: 'Svatý Kryštof a Nevis',
                KP: 'Severní Korea',
                KR: 'Jižní Korea',
                KW: 'Kuvajt',
                KY: 'Kajmanské ostrovy',
                KZ: 'Kazachstán',
                LA: 'Laos',
                LB: 'Libanon',
                LC: 'Svatá Lucie',
                LI: 'Lichtenštejnsko',
                LK: 'Srí Lanka',
                LR: 'Libérie',
                LS: 'Lesotho',
                LT: 'Litva',
                LU: 'Lucembursko',
                LV: 'Lotyšsko',
                LY: 'Libye',
                MA: 'Maroko',
                MC: 'Monako',
                MD: 'Moldavsko',
                ME: 'Černá Hora',
                MF: 'Svatý Martin (francouzská část)',
                MG: 'Madagaskar',
                MH: 'Marshallovy ostrovy',
                MK: 'Severní Makedonie',
                ML: 'Mali',
                MM: 'Myanmar',
                MN: 'Mongolsko',
                MO: 'Macao',
                MP: 'Severní Mariany',
                MQ: 'Martinik',
                MR: 'Mauritánie',
                MS: 'Montserrat',
                MT: 'Malta',
                MU: 'Mauricius',
                MV: 'Maledivy',
                MW: 'Malawi',
                MX: 'Mexiko',
                MY: 'Malajsie',
                MZ: 'Mosambik',
                NA: 'Namibie',
                NC: 'Nová Kaledonie',
                NE: 'Niger',
                NF: 'Norfolk',
                NG: 'Nigérie',
                NI: 'Nikaragua',
                NL: 'Nizozemsko',
                NO: 'Norsko',
                NP: 'Nepál',
                NR: 'Nauru',
                NU: 'Niue',
                NZ: 'Nový Zéland',
                OM: 'Omán',
                PA: 'Panama',
                PE: 'Peru',
                PF: 'Francouzská Polynésie',
                PG: 'Papua Nová Guinea',
                PH: 'Filipíny',
                PK: 'Pákistán',
                PL: 'Polsko',
                PM: 'Saint Pierre a Miquelon',
                PN: 'Pitcairnovy ostrovy',
                PR: 'Portoriko',
                PS: 'Palestinská autonomie',
                PT: 'Portugalsko',
                PW: 'Palau',
                PY: 'Paraguay',
                QA: 'Katar',
                RE: 'Réunion',
                RO: 'Rumunsko',
                RS: 'Srbsko',
                RU: 'Rusko',
                RW: 'Rwanda',
                SA: 'Saúdská Arábie',
                SB: 'Šalomounovy ostrovy',
                SC: 'Seychely',
                SD: 'Súdán',
                SE: 'Švédsko',
                SG: 'Singapur',
                SH: 'Svatá Helena, Ascension a Tristan da Cunha',
                SI: 'Slovinsko',
                SJ: 'Špicberky a Jan Mayen',
                SK: 'Slovensko',
                SL: 'Sierra Leone',
                SM: 'San Marino',
                SN: 'Senegal',
                SO: 'Somálsko',
                SR: 'Surinam',
                SS: 'Jižní Súdán',
                ST: 'Svatý Tomáš a Princův ostrov',
                SV: 'Salvador',
                SX: 'Svatý Martin (nizozemská část)',
                SY: 'Sýrie',
                SZ: 'Svazijsko',
                TC: 'Turks a Caicos',
                TD: 'Čad',
                TF: 'Francouzská jižní a antarktická území',
                TG: 'Togo',
                TH: 'Thajsko',
                TJ: 'Tádžikistán',
                TK: 'Tokelau',
                TL: 'Východní Timor',
                TM: 'Turkmenistán',
                TN: 'Tunisko',
                TO: 'Tonga',
                TR: 'Turecko',
                TT: 'Trinidad a Tobago',
                TV: 'Tuvalu',
                TW: 'Tchaj-wan',
                TZ: 'Tanzanie',
                UA: 'Ukrajina',
                UG: 'Uganda',
                UM: 'Menší odlehlé ostrovy USA',
                US: 'Spojené státy americké',
                UY: 'Uruguay',
                UZ: 'Uzbekistán',
                VA: 'Vatikán',
                VC: 'Svatý Vincenc a Grenadiny',
                VE: 'Venezuela',
                VG: 'Britské Panenské ostrovy',
                VI: 'Americké Panenské ostrovy',
                VN: 'Vietnam',
                VU: 'Vanuatu',
                WF: 'Wallis a Futuna',
                WS: 'Samoa',
                YE: 'Jemen',
                YT: 'Mayotte',
                ZA: 'Jihoafrická republika',
                ZM: 'Zambie',
                ZW: 'Zimbabwe'
            },
            GENDER: {
                Male: 'Muž',
                Female: 'Žena'
            },
            MARTIAL_STATUS: {
                UNMARRIED: 'Svobodný/á',
                MARRIED: 'Ženatý/Vdaná',
                DIVORCED: 'Rozvedený/á',
                COHABITATION: 'Soužití',
                WIDOWED: 'Ovdovělý/á'
            },
            EDU: {
                PRIMARY: 'Základní',
                HIGH_SCHOOL_WITHOUT_DIPLOMA: 'Středoškolské bez maturity',
                HIGH_SCHOOL_WITH_DIPLOMA: 'Středoškolské s maturitou',
                HIGHER_VOCATIONAL: 'Vyšší odborná škola (Dis.)',
                UNIVERSITY_LOWER: 'Bakalářský titul (Bc.)',
                UNIVERSITY: 'Vysokoškolské vzdělání (Mgr., Ing., MUDr.)',
                UNIVERSITY_HIGHER: 'Doktorandský titul (PhD., Dr., Doc., Prof.)'
            },
            CONTRACT_STATUS: {
                CREATED: 'Vytvořeno',
                RETURNED: 'Vráceno',
                DELETED: 'Smazáno',
                SENT_TO_HQ: 'Odesláno na centrálu',
                RECEIVED_BY_HQ: 'Převzato centrálou',
                SCANNED: 'Naskenováno',
                SENT_TO_PARTNER: 'Odesláno na partnera',
                RECEIVED_BY_PARTNER: 'Převzato partnerem',
                ACCEPTED: 'Přijato',
                DISMISSED: 'Zamítnuto',
                CANCELLED: 'Zrušeno'
            },
            RISK_FACTOR: {
                FUND_ORIGIN_RISK_FACTOR: 'Nejasný původ prostředků',
                ANOTHER_ACCOUNT_RISK_FACTOR: 'Podezření, že klient nejedná na svůj účet',
                UNUSUAL_TRADE_RISK_FACTOR: 'Neobvyklý způsob realizace obchodu',
                SUSPECT_TRADE_RISK_FACTOR: 'Podezření na uskutečnění podezřelého obchodu',
                FROM_RISK_COUNTRY_RISK_FACTOR: 'Klient pochází z rizikové země',
                CLIENT_WITH_SANCTIONS_RISK_FACTOR: 'Klient vůči kterému jsou uplatňovány sankce',
                OWNERSHIP_STRUCTURE_RISK_FACTOR: 'Neprůhledná vlastnická struktura',
                POLITICALLY_EXPOSED_RISK_FACTOR: 'Politicky exponovaná osoba'
            },
            IDENTITY_CARD: {
                IDENTITY_CARD: 'Občanský průkaz',
                PASSPORT: 'Cestovní pas',
                RESIDENCE_PERMIT: 'Povolení k pobytu',
            }
        }
    }
};
